import {
  EMPLOYMENT_TYPE_CONSULTANT,
  EMPLOYMENT_TYPE_SIMFLEXITY_EMPLOYEE,
  EMPLOYMENT_TYPE_TRAINEE,
} from "model/OrganizationalStructure";
import { SalaryType } from "model/Salary";

export interface EmploymentFieldVisibility {
  showSalaryType: boolean;
  showSalary: boolean;
  showPaymentType: boolean;
  showTaxTable: boolean;
  showEmployeeCategory: boolean;
  showContractTerms: boolean;
}

/**
 * Determines which employment form fields are shown for a given employment type:
 * - Simflexity employees hide employee category, tax table and contract terms
 *   (salary model is forced to hourly and payment to SimflexityPay elsewhere).
 * - Trainees and consultants additionally hide salary model, salary and payment.
 * - All other types show every field.
 */
export const getEmploymentFieldVisibility = (
  employmentType: string | undefined,
): EmploymentFieldVisibility => {
  const isSimflexityEmployee =
    employmentType === EMPLOYMENT_TYPE_SIMFLEXITY_EMPLOYEE;
  const isTraineeOrConsultant =
    employmentType === EMPLOYMENT_TYPE_TRAINEE ||
    employmentType === EMPLOYMENT_TYPE_CONSULTANT;

  if (isTraineeOrConsultant) {
    return {
      showSalaryType: false,
      showSalary: false,
      showPaymentType: false,
      showTaxTable: false,
      showEmployeeCategory: false,
      showContractTerms: false,
    };
  }

  if (isSimflexityEmployee) {
    return {
      showSalaryType: true,
      showSalary: true,
      showPaymentType: true,
      showTaxTable: false,
      showEmployeeCategory: false,
      showContractTerms: false,
    };
  }

  return {
    showSalaryType: true,
    showSalary: true,
    showPaymentType: true,
    showTaxTable: true,
    showEmployeeCategory: true,
    showContractTerms: true,
  };
};

export interface VacationFieldVisibility {
  showVacationEarningDays: boolean;
  showVacationPayoutType: boolean;
}

export const getVacationFieldVisibility = (
  salaryType: string | null | undefined,
): VacationFieldVisibility => {
  return {
    showVacationEarningDays: salaryType === SalaryType.Monthly,
    showVacationPayoutType: salaryType === SalaryType.Hourly,
  };
};
